import { UpperCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	BadgeComponent,
	CardSelectComponent,
	CollapseComponent,
	InfoGroupComponent,
	TileComponent,
} from '@tecalisdev/infinity';
import {
	CONNECTION_TYPE,
	EVALUATION_TYPE,
	IConnectionOperation,
} from '../../../../../operations/models/operations.models';
import { DeveloperCurlButtonComponent } from '../../../../../shared/components/developer-curl-button/developer-curl-button.component';

@Component({
	selector: 'app-financial-evaluation-operation',
	imports: [
		TranslatePipe,
		UpperCasePipe,
		TileComponent,
		CollapseComponent,
		InfoGroupComponent,
		BadgeComponent,
		CardSelectComponent,
		DeveloperCurlButtonComponent,
	],
	templateUrl: './financial-evaluation-operation.component.html',
	styleUrl: './financial-evaluation-operation.component.scss',
})
export class FinancialEvaluationOperationComponent implements OnInit {
	@Input() operation?: IConnectionOperation;
	@Input() index: number = 1;
	@Input() profileUuid?: string;

	public CONNECTION_TYPE = CONNECTION_TYPE;
	public EVALUATION_TYPE = EVALUATION_TYPE;

	ngOnInit(): void {}

	public operationCurlPath(): string {
		if (!this.profileUuid || !this.operation?.uuid) return '';
		return `/profile/${this.profileUuid}/operations/${this.operation.uuid}`;
	}
}
